"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationEntryBaseToJSON = exports.NavigationEntryBaseFromJSONTyped = exports.NavigationEntryBaseFromJSON = void 0;
function NavigationEntryBaseFromJSON(json) {
    return NavigationEntryBaseFromJSONTyped(json, false);
}
exports.NavigationEntryBaseFromJSON = NavigationEntryBaseFromJSON;
function NavigationEntryBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayName': json['displayName'],
        'url': json['url'],
    };
}
exports.NavigationEntryBaseFromJSONTyped = NavigationEntryBaseFromJSONTyped;
function NavigationEntryBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'displayName': value.displayName,
        'url': value.url,
    };
}
exports.NavigationEntryBaseToJSON = NavigationEntryBaseToJSON;
//# sourceMappingURL=NavigationEntryBase.js.map